import React from "react"
import PropTypes from "prop-types"
import "./empty_state_component.scss"

import logIFTTTNextAction from "app/lib/ifttt_next_log_action"

export default class EmptyStateComponent extends React.Component {
  onGetMoreButtonClick = () => {
    logIFTTTNextAction("click", {
      location_type: "home",
      object_type: "get_more_button",
    })
  }

  render() {
    return (
      <>
        <h1 styleName="empty-state-header">Start connecting your world.</h1>
        <img
          styleName="empty-state-hero-img"
          src={this.props.heroImages[0]}
          srcSet={`${this.props.heroImages[0]}, ${this.props.heroImages[1]} 2x, ${this.props.heroImages[2]} 3x`}
          alt="Get started using IFTTT"
        />
        <a
          styleName="get-more-button"
          className="btn btn-lg"
          style={{ backgroundColor: `${this.props.buttonColor}` }}
          onClick={this.onGetMoreButtonClick}
          role="button"
          href={this.props.buttonLink}
        >
          Get more
        </a>
      </>
    )
  }
}

EmptyStateComponent.propTypes = {
  buttonColor: PropTypes.string.isRequired,
  buttonLink: PropTypes.string,
  heroImages: PropTypes.array,
}

EmptyStateComponent.defaultProps = {
  buttonLink: "/get_more",
}
